import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

import { FrmLocation } from "components/formFields/frm/FrmLocation";

import { i18n } from "services/i18nService";
import { generateTransfer } from "services/sosInventoryService/sosApi";
import { handleProgramError } from "services/utility/errors";

import { openAlert } from "globalState/alertSlice";
import {
  loadingIndicatorOn,
  loadingIndicatorOff,
} from "globalState/loadingSlice";

export function GenerateTransferDialog(props) {
  const { open, onClose, checkedIds, settings } = props;
  const dispatch = useDispatch();

  const allowNegativeInventory = useSelector(
    (state) => state.userCompanySettings.settings.allowNegativeInventory
  );
  const [fromLocation, setFromLocation] = useState(null);

  async function handleGenerateTransfer() {
    dispatch(loadingIndicatorOn());
    const params = {
      items: checkedIds,
      toLocationId: settings.locations[0]?.id,
      fromLocationId: fromLocation?.id,
      includePOs: settings.includePOs,
      includeRMAs: settings.includeRMAs,
      includeWOs: settings.includeWOs,
      includeRentals: settings.includeRentals,
      includeNulls: settings.includeNulls,
    };
    const { success, message } = await generateTransfer(params);
    if (success) {
      const message = allowNegativeInventory
        ? i18n("alert.SuccessGenerateTransfer.AllowNegativeInventory")
        : i18n("alert.SuccessGenerateTransfer");
      dispatch(openAlert({ type: "success", message }));
      dispatch(loadingIndicatorOff());
      onClose();
    } else {
      dispatch(loadingIndicatorOff());
      const errorMessage = message || i18n("alert.ErrorGeneratingPos");
      handleProgramError(new Error(errorMessage));
    }
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          {i18n("reports.GenerateTransferFor")} {checkedIds.length}{" "}
          {i18n("reports.selectedItems")}
        </DialogContentText>
        <FrmLocation
          disableClearable
          name="fromLocation"
          value={fromLocation}
          label={i18n("frmLabel.FromLocation")}
          onValueChange={(_, value) => setFromLocation(value)}
          width="25rem"
        />
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose}>
          {i18n("button.Cancel")}
        </Button>
        <div style={{ position: "relative" }}>
          <Button
            color="secondary"
            disabled={!fromLocation}
            onClick={handleGenerateTransfer}
          >
            {i18n("reports.GenerateTransfer")}
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
}
